import React from 'react';
import SiteHeader from "../../../components/Template/SiteHeader";
import SignUpBanner from "../../../components/Banner/SignUpBanner";
import Footer from "../../../components/Template/Footer";
import Summary from "./Summary";

const SummaryWrapper: React.FC = () => {
  return (
      <div className="min-h-screen bg-white flex flex-col relative">
        <section className="bg-center bg-cover bg-no-repeat"
                 style={{backgroundImage: "url('/images/background-header.jpg')"}}>
          <SiteHeader/>
          <SignUpBanner/>
        </section>
        <section className="grow">
          <Summary/>
        </section>
        <Footer/>
      </div>
  );
};

export default SummaryWrapper;
